import "core-js/modules/es.array.push.js";
import { queryService, idctitle, queryWeakEngineer, queryIsr, queryOperation, queryCount, sheji, xinwen, xinwenlift, cowNewsMainNewsList, viewsadd, queryDesign, cowCooperativePartnerGetInfo, cowCooperativePartnerDetailList, queryDesignDetail, getCowVideo } from "../../../request/api";
import { Notify } from 'vant';
import { Toast } from 'vant';
import Swiper from "swiper";
// import { url } from "inspector";
const statisticsEnum = [{
  key: "companyEstablishedTime",
  text: "鼎峰成立于"
}, {
  key: "serviceExperience",
  text: "互联网服务经验"
}, {
  key: "ipr",
  text: "自主知识产权"
}, {
  key: "serviceCustomers",
  text: "服务客户"
}];
export default {
  data() {
    return {
      background: "",
      list: [],
      swipew: [],
      ruodains: [],
      jichengs: [],
      tongjis: [],
      statistics: [],
      queryDesign: [],
      xinwenlift: [],
      id: null,
      ids: 0,
      itemId: null,
      xinwenzixun: [],
      yunweis: [],
      cowCooperativePartnerGetInfo: [],
      cowCooperative: {},
      cowCooperativePartnerDetailList: [],
      orn: [],
      orns: [],
      queryDesignDetail: [],
      listindex: [
      // { img: require("../../../assets/mobileimg/gn-img.jpg") },
      // { img: require("../../../assets/mobileimg/newyear2025-mobile.jpg") },
      {
        img: require("../../../assets/mobileimg/indexads.png"),
        serviceTitle: '让技术与生活更融洽',
        serviceTitlesw: '期待与您一起构建智能未来',
        serviceTitleswz: '了解更多'
      }, {
        img: require("../../../assets/mobileimg/852x.png")
      }, {
        img: require("../../../assets/mobileimg/mobilebanner.png")
      }],
      image: [{
        name: require("../../../assets/mobileimg/Slice 444.png")
      }, {
        name: require("../../../assets/mobileimg/Slice 177.png")
      }, {
        name: require("../../../assets/mobileimg/Slice 178.png")
      }, {
        name: require("../../../assets/mobileimg/Slice 444.png")
      }, {
        name: require("../../../assets/mobileimg/Slice 177.png")
      }, {
        name: require("../../../assets/mobileimg/Slice 178.png")
      }, {
        name: require("../../../assets/mobileimg/Slice 444.png")
      }, {
        name: require("../../../assets/mobileimg/Slice 177.png")
      }, {
        name: require("../../../assets/mobileimg/Slice 178.png")
      }, {
        name: require("../../../assets/mobileimg/Slice 444.png")
      }, {
        name: require("../../../assets/mobileimg/Slice 444.png")
      }],
      videos: "",
      startX: '',
      startY: '',
      moveY: '',
      moveX: '',
      startTime: '',
      current: 0,
      titName: "",
      show: false,
      indeximg: [{
        img: require("../../../assets/mobileimg/indexas2x.png")
      }, {
        img: require("../../../assets/mobileimg/indexaqw2x.png")
      }, {
        img: require("../../../assets/mobileimg/indexasda2x.png")
      }],
      bookSwiper: [{
        img: "http://pic.qingting.fm/2017/0228/20170228173809513.jpg!medium",
        cntname: "错嫁良缘之一代军师"
      }, {
        img: "http://pic.qingting.fm/2017/0228/20170228173809513.jpg!medium",
        cntname: "鬼墓迷灯"
      }, {
        img: "http://pic.qingting.fm/2017/0228/20170228173809513.jpg!medium",
        cntname: "九霄灵帝"
      }]
    };
  },
  methods: {
    onChange(index) {
      this.current = index;
    },
    // 访问首页增加浏览量服务
    getviewsadd() {
      viewsadd().then(res => {});
    },
    // 服务器租赁跳转
    btnClick(index) {
      if (index == 0) {
        this.$router.push("/mobile/fuwuqi");
      }
      if (index == 1) {
        this.$router.push("/mobile/yuming");
      }
      if (index == 2) {
        this.$router.push("/mobile/ssl");
      }
    },
    //了解更多
    rout() {
      this.show = true;
      // this.$router.push("/home/customize");
    },

    // 跳转弱电
    btnrd() {
      this.$router.push("/home/weakCurrent");
    },
    // 跳转集成
    btnjc() {
      this.$router.push("/home/integration");
    },
    // 跳转运维
    btnyw() {
      this.$router.push("/home/maintenance");
    },
    routanck(index) {
      if (index == 0) {
        this.$router.push("/home/customize");
      }
      if (index == 1) {
        this.$router.push("/home/template");
      }
      if (index == 2) {
        this.$router.push("/home/property");
      }
    },
    // 跳转新闻动态
    btnxwdt() {
      this.$router.push("/home/newsActive");
    },
    // 查询新闻咨询右侧
    chxinwen() {
      cowNewsMainNewsList({
        action: "cowNewsMainNewsList"
      }).then(res => {
        this.xinwenlift = res.data.cowNewsList[0];
        this.xinwenliftId = res.data.cowNewsList[0].id;
        this.xinwenzixun = res.data.cowNewsList;
      });
    },
    //跳转合作伙伴
    cooperative() {
      this.$router.push("/home/addbrand");
    },
    // 跳转新闻查看更多
    xinwen(e) {
      let id = e;
      this.$router.push({
        path: "newsDetails",
        query: {
          id: id
        }
      });
    },
    // 设计类型
    getqueryDesign() {
      sessionStorage.setItem("mobiletype", 0);
      queryDesign({
        action: "queryDesign",
        data: {
          cowDesignForm: {
            ascField: "sort",
            type: 0
          }
        }
      }).then(res => {
        if (sessionStorage.getItem("mobiledesignindex") && sessionStorage.getItem("mobiledesignitemId") && sessionStorage.getItem("mobiledesigntitle")) {
          console.log(window.sessionStorage.getItem("mobiledesignindex"));
          console.log(window.sessionStorage.getItem("mobiletype"));
          console.log(window.sessionStorage.getItem("mobiledesignitemId"));
          console.log(window.sessionStorage.getItem("mobiledesigntitle"));
          this.ids = window.sessionStorage.getItem("mobiledesignindex");
          // this.type = window.sessionStorage.getItem("mobiletype")
          this.titName = window.sessionStorage.getItem("mobiledesigntitle");
          this.itemId = window.sessionStorage.getItem("mobiledesignitemId");
          this.background = window.sessionStorage.getItem("mobiledesignbackground");
          this.queryDesign = res.data.designInfos;
          this.getqueryDesignDetail();
        } else {
          this.queryDesign = res.data.designInfos;
          this.itemId = res.data.designInfos[0].id;
          this.titName = res.data.designInfos[0].designTitle;
          this.background = res.data.designInfos[0].backgroundImg;
          this.getqueryDesignDetail();
        }
      });
    },
    // 设计类型点击
    getdesign(index, item, backgroundImg) {
      this.background = backgroundImg;
      this.ids = index;
      this.itemId = item.id;
      this.titName = item.designTitle;
      window.sessionStorage.setItem("mobiletype", 0);
      window.sessionStorage.setItem("mobiledesignindex", this.ids);
      window.sessionStorage.setItem("mobiledesignitemId", this.itemId);
      window.sessionStorage.setItem("mobiledesigntitle", this.titName);
      window.sessionStorage.setItem("mobiledesignbackground", this.background);
      this.getqueryDesignDetail();
    },
    // 设计首页3个
    getqueryDesignDetail() {
      queryDesignDetail({
        action: "queryDesignDetail",
        data: {
          cowDesignDetailForm: {
            designId: this.itemId,
            page: "1",
            rows: "6",
            ascField: "sort"
          }
        }
      }).then(res => {
        this.queryDesignDetail = res.data.designDetailInfos.slice(0, 3);
      });
    },
    // // 早安图跳转
    // goodmorning(titobj, item) {
    //   if (this.ids == 1) {
    //     window.sessionStorage.setItem("publishTime", JSON.stringify(item.publishTime))
    //     this.$router.push("/home/billAppParticulars")
    //   } else {
    //     window.sessionStorage.setItem("jcdfkj_details", JSON.stringify(item))
    //     this.$router.push({
    //       path: "/home/APPitem",
    //       query: {
    //         titobj: JSON.stringify(titobj),
    //         item: JSON.stringify(item)
    //       },
    //     });
    //   }

    // },
    // 点击每一项item
    getitem(titobj, item, index) {
      if (this.ids == 1 && index == 0) {
        this.$router.push("/home/billAppParticulars");
      } else {
        window.sessionStorage.setItem("details", JSON.stringify(item));
        // this.$router.push("/home/APPitem");
        this.$router.push({
          path: '/home/APPitem',
          query: {
            id: item.id
          }
        });
      }
    },
    // 设计查看更多
    getmore() {
      window.sessionStorage.setItem("mobiletype", 0);
      window.sessionStorage.setItem("mobiledesignindex", this.ids);
      window.sessionStorage.setItem("mobiledesignitemId", this.itemId);
      window.sessionStorage.setItem("mobiledesigntitle", this.titName);
      window.sessionStorage.setItem("mobiledesignbackground", this.background);
      this.$router.push({
        path: "/home/allAPP"
      });
    },
    // 合作伙伴文本
    getcowCooperativePartnerGetInfo() {
      cowCooperativePartnerGetInfo({
        action: "cowCooperativePartnerGetInfo",
        data: {
          id: "1"
        }
      }).then(res => {
        this.cowCooperativePartnerGetInfo = res.data.cowCooperativePartner;
      });
    },
    // 合作伙伴列表查询
    getcowCooperativePartnerDetailList() {
      cowCooperativePartnerDetailList({
        action: "cowCooperativePartnerDetailList",
        data: {
          cowCooperativePartnerDetailForm: {
            page: 1,
            rows: 100,
            ascField: 'sort'
          }
        }
      }).then(res => {
        this.cowCooperative = res.data;
        this.cowCooperativePartnerDetailList = res.data.cowCooperativePartnerDetailList;
        this.orn = res.data.cowCooperativePartnerDetailList.slice(0, 6);
        this.orns = res.data.cowCooperativePartnerDetailList.slice(6, 10);
      });
    },
    //查询弱电工程
    weakcurrent() {
      queryWeakEngineer({
        action: "queryWeakEngineer"
      }).then(res => {
        this.ruodains = res.data.weakEngineerInfos;
      });
    },
    //查询集成系统
    integrate() {
      queryIsr({
        action: "queryIsr"
      }).then(res => {
        this.jichengs = res.data.isrInfos;
      });
    },
    //查询运维服务
    operation() {
      queryOperation({
        action: "queryOperation"
      }).then(res => {
        this.yunweis = res.data.operationInfos;
      });
    },
    //服务统计
    Statistics() {
      queryCount({
        action: "queryCount"
      }).then(res => {
        this.tongjis = res.data.countInfos;
        let newVar = this.tongjis[0];
        const statisticsList = [];
        statisticsEnum.forEach(item => {
          if (newVar[item.key] != null && newVar[item.key] > 10000) {
            statisticsList.push({
              number: `${newVar[item.key]}`.substring(0, `${newVar[item.key]}`.length - 4),
              companyIsShow: true,
              text: item.text
            });
          } else {
            statisticsList.push({
              number: newVar[item.key],
              companyIsShow: false,
              text: item.text,
              key: item.key
            });
          }
        });
        this.statistics = statisticsList;
      });
    },
    // 首页视频
    getCowVideo() {
      getCowVideo({
        action: "getCowVideo",
        data: {
          type: "0"
        }
      }).then(res => {
        console.log(res, "首页视频");
        this.videos = res.data.cowVideo.video;
      });
    },
    goRoute({
      id
    }) {
      if (id == 1) {
        this.$router.push('/home/server');
      } else if (id == 4) {
        this.$router.push('/mobile/mobilecloud');
      } else if (id == 9) {
        // this.$router.push('/mobile/theServer')
      } else if (id == 2) {
        this.$router.push('/home/domain');
      } else if (id == 5) {
        this.$router.push('/mobile/commercecloud');
      } else if (id == 10) {
        //this.$router.push('/mobile/theServer')
      } else if (id == 3) {
        this.$router.push('/home/ssl');
      } else if (id == 6) {
        this.$router.push('/mobile/gamecloud');
      } else if (id == 11) {
        //this.$router.push('/mobile/theServer')
      } else if (id == 7) {
        this.$router.push('/mobile/websitecloud');
      } else if (id == 8) {
        this.$router.push('/mobile/finance');
      }
    },
    // idc
    getIdc() {
      idctitle({
        action: "queryIdc",
        data: {
          type: 0
        }
      }).then(res => {
        this.swipew = res.data.idcInfos;
      });
    }
  },
  mounted() {
    const id = this.$route.query.id;
    this.getIdc();
    // 服务领域标题内容
    queryService({
      action: "queryService"
    }).then(res => {
      this.list = res.data.services;
    });

    //合作伙伴列表
    this.getcowCooperativePartnerDetailList();

    // 查询弱电工程
    this.weakcurrent();

    // 查询集成系统
    this.integrate();

    // 查询运维服务
    this.operation();

    // 查询网站统计
    this.Statistics();
    // 查询设计
    // 新闻咨询
    this.chxinwen();
    // 设计类型
    this.getqueryDesign();
    // 首页视频
    this.getCowVideo();
    //合作伙伴文本
    this.getcowCooperativePartnerGetInfo();
    this.$nextTick(() => {
      setTimeout(() => {
        new Swiper("#swiper1", {
          direction: "horizontal",
          speed: 300,
          loop: true,
          loopedSlides: 5,
          autoplay: true,
          observer: true,
          observeParents: true,
          effect: "coverflow",
          slidesPerView: "auto",
          centeredSlides: true,
          coverflowEffect: {
            rotate: 0,
            //slide做3d旋转时Y轴的旋转角度。默认50。
            stretch: -10,
            //每个slide之间的拉伸值，越大slide靠得越紧。 默认0。
            depth: 20,
            //slide的位置深度。值越大z轴距离越远，看起来越小。 默认100。
            modifier: 5,
            slideShadows: false //开启slide阴影。默认 true。
          },

          pagination: {
            el: ".swiper-pagination",
            clickable: true
          }
        });
      }, 300);
    });
  }
};